import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateAddressMutation as _UpdateAddressMutation,
  UpdateAddressInput,
} from '@/gql/graphql';
import { pick } from 'lodash-es';

const UpdateAddressMutation = graphql(`
  mutation UpdateAddress($input: UpdateAddressInput!) {
    updateAddress(input: $input) {
      id
    }
  }
`);

const useUpdateAddress = (
  options?: UseMutationOptions<
    _UpdateAddressMutation,
    unknown,
    UpdateAddressInput
  >
) => {
  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(UpdateAddressMutation, {
        input: pick(input, [
          'city',
          'contacts',
          'country',
          'id',
          'line1',
          'line2',
          'postalCode',
        ]),
      });
    },
    ...options,
  });
};

export default useUpdateAddress;
